import React, { useCallback, useContext, useEffect, useState } from 'react';

import { getPendingApprovals } from '@totem/components/ticketing/approval_utilities';
import ApprovalItem from '@totem/components/ticketing/details/approvals/approvalItem';
import TicketContext from '@totem/components/ticketing/details/ticketContext';
import { SelectedApprovals } from '@totem/components/ticketing/ticketing';
import NaPartyInvolvedContext from '@totem/components/unauthenticated/ticketing/details/partyInvolved/naPartyInvolvedContext';
import { isNotNull } from '@totem/utilities/common';
import { UNAUTHENTICATED_TICKET_ENDPOINT } from '@totem/utilities/endpoints';
import { CheckResponseShowError } from '@totem/utilities/responseUtilities';

const NAApprovalSection = () => {
  const { partyInvolved, token } = useContext(NaPartyInvolvedContext);
  const { ticket, onAction } = useContext(TicketContext);
  const [isSending, setIsSending] = useState(false);
  const [pendingApprovals, setPendingApprovals] = useState<SelectedApprovals[]>(
    [],
  );

  useEffect(() => {
    if (isNotNull(ticket) && isNotNull(partyInvolved)) {
      const selected = getPendingApprovals(partyInvolved.email, ticket);
      setPendingApprovals(selected);
    }
  }, [ticket, partyInvolved]);

  const sendApproval = useCallback(
    async (approval: SelectedApprovals) => {
      if (isSending) {
        return;
      }

      fetch(
        `${UNAUTHENTICATED_TICKET_ENDPOINT}/approval/${approval.approvalRequest.id}`,
        {
          method: 'POST',
          headers: new Headers({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          }),
          body: JSON.stringify(approval.approval),
        },
      ).then((res) => {
        setIsSending(false);
        const success = CheckResponseShowError(res);
        if (success) {
          onAction('refresh', '');
        }
      });

      setIsSending(true);
    },
    [isSending],
  );

  const handleUpdate = (approval: SelectedApprovals) => {
    sendApproval(approval);
  };

  if (pendingApprovals.length === 0) {
    return <span />;
  }

  return (
    <div style={{ backgroundColor: '#FFF3E0', padding: '16px' }}>
      <div
        style={{
          fontSize: 18,
          fontWeight: 700,
        }}
      >
        Pending Approvals
      </div>
      <br />
      {pendingApprovals &&
        pendingApprovals.map((approval) => (
          <ApprovalItem
            key={approval.approval.id}
            approval={approval}
            onUpdate={handleUpdate}
          />
        ))}
    </div>
  );
};

export default NAApprovalSection;
